export const BrandLogo = ({ subtitle = "Hospitality Group", size = "h-11 w-11", text = "text-2xl" }) => (
  <span className="flex items-center gap-3 leading-none">
    <img src="/brand/logo-circle.png" alt="Aurelia Hospitality Group" className={`${size} shrink-0 rounded-full`} data-testid="brand-logo-img" />
    <span className="flex flex-col">
      <span className={`font-serif ${text} tracking-[0.08em] text-[var(--aur-text)]`}>AURELIA</span>
      {subtitle && <span className="eyebrow mt-1 text-[0.58rem]">{subtitle}</span>}
    </span>
  </span>
);
